import { ErrorResponse } from "@types"
import customFetch from "./helper"

/**
 * This is the base API endpoint for blogs.
 */
const API = "/farcaster/v3"

/**
 * Used when a subscriber is organically subscribing to a blog
 * (e.g. a writer is NOT adding them manually to their blog).
 *
 * NOTE! This is a very barebones implementation that should be updated to
 * reflect what subscribeUserToBlog was doing in the old nextJS directory
 * (with custom domain cookies, etc.) once we migrate that functionality over.
 */
export async function subscribeUserToBlogViaFrame({
  lowercaseBlogUrl,
  custodyAddress,
}: {
  lowercaseBlogUrl: string
  custodyAddress: string
}): Promise<ErrorResponse | { subscribed: boolean } | null> {
  try {
    const response = await customFetch<
      ErrorResponse | { subscribed: boolean } | null
    >(`${API}/frame/subscribe/${lowercaseBlogUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ custodyAddress }),
    })

    return response
  } catch (e) {
    console.error("Error subscribing user to blog:", e)
    return null
  }
}
